import { ThunkAction } from 'redux-thunk';
import { AuthAction, singInData, LOGIN_REQUEST, VERIFY_TOKEN, LOGIN_SUCCESS, LOGIN_FAILURE, lOGOUT_REQUEST, LOADING } from '../types/actions';
import { RootState } from '../store';
import { RequestInitPost } from '../../components/shared/RequestInit';

export const login = (data: singInData | null): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            const RequestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: "include",
                body: JSON.stringify({ username: data?.username, password: data?.password })
            };
            await fetch(`https://admin.radioemotion.be/api/login`, RequestInit as RequestInit)
                .then(response => response.json())
                .then(response => {
                    if (response.response === true) {
                        console.log(response.data.adminRole)
                        dispatch({
                            type: LOGIN_SUCCESS,
                            payload: { username: response.data.username, adminRole: response.data.adminRole }
                        });
                    }else if(response.response === false){
                        dispatch({
                            type: lOGOUT_REQUEST
                        });
                    }
                })
                .catch(err => {
                    dispatch(setError("error"));
                    dispatch(setLoading(false))
                })
        } catch (err) {
            console.log("error")
            dispatch(setError("error"));
        }
    }
}


export const setError = (msg: string): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: LOGIN_FAILURE,
            payload: msg
        });
    }
}

// Log in
export const signin = (data: singInData, onError: () => void): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            // await 
        } catch (err) {
            console.log(err);
            onError();
            dispatch(setError(err.message));
        }
    }
}



// Log in
export const setLoading = (value: boolean): ThunkAction<void, RootState, null, AuthAction> => {
    return dispatch => {
        dispatch({
            type: LOADING,
            payload: value
        })
    }
}


export const verifyToken = (): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            const RequestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: "include",
            };
            await fetch(`https://admin.radioemotion.be/api/verifytoken`, RequestInit as RequestInit)
                .then(response => response.json())
                .then(response => {
                    if(response.response === true){
                        //not needed if token is valid
                        // dispatch({
                        //     type: VERIFY_TOKEN,
                        //     payload: true
                        // });
                    }
                    else if(response.response === false){
                        dispatch({
                            type: lOGOUT_REQUEST
                        });
                    }
                })
                .catch(err => {
                    dispatch(setError("error"));
                })
        } catch (err) {
            dispatch(setError("error"));
        }
    }
}


export const logout = (): ThunkAction<void, RootState, null, AuthAction> => {
    return async dispatch => {
        try {
            await fetch(`https://admin.radioemotion.be/api/logout`, RequestInitPost as RequestInit)
                .then(response => response.json())
                .then(response => {
                    if(response.response === true){
                        dispatch({
                            type: lOGOUT_REQUEST                           
                        });
                    }
                    else{
                        console.log("loggin error in reponse")
                    }
                })
                .catch(err => {
                    dispatch(setError("error"));
                })
        } catch (err) {
            dispatch(setError("error"));
        }
    }
}
